/**
 * QuickBooks accounts eligible for reconciliation.
 * Source of truth: queried from QB gateway on 2026-04-07.
 * Excludes "RBC Edge Virtual Wallet" per user decision.
 */

export interface ReconcilableAccount {
  id: string;
  name: string;
  kind: 'bank' | 'credit_card';
  subtype: string;
}

export const RECONCILABLE_ACCOUNTS: ReconcilableAccount[] = [
  // Bank
  { id: '204', name: 'Bank RBC Deferred Revenues 4082', kind: 'bank', subtype: 'Checking' },
  { id: '15', name: 'Bank RBC Government 8183', kind: 'bank', subtype: 'Checking' },
  { id: '14', name: 'Bank RBC Operation 8100', kind: 'bank', subtype: 'Checking' },
  { id: '1150040020', name: 'Bank RBC Savings 4082', kind: 'bank', subtype: 'Savings' },
  { id: '19', name: 'Bank RBC Savings 4397', kind: 'bank', subtype: 'Savings' },
  // Credit cards
  { id: '36', name: 'Credit Card RBC Hakim (**7810)', kind: 'credit_card', subtype: 'CreditCard' },
  { id: '200', name: 'Credit Card RBC Marketing (**0858)', kind: 'credit_card', subtype: 'CreditCard' },
  { id: '199', name: 'Credit Card RBC Operations (**8094)', kind: 'credit_card', subtype: 'CreditCard' },
  { id: '201', name: 'Credit Card RBC Platform (**8037)', kind: 'credit_card', subtype: 'CreditCard' },
  { id: '118', name: 'Line of Credit', kind: 'credit_card', subtype: 'CreditCard' },
];

export function getAccountName(id: string | null | undefined): string {
  if (!id) return '—';
  return RECONCILABLE_ACCOUNTS.find((a) => a.id === id)?.name ?? id;
}
